
import DirectboxNotif from "../../../assets/duotone/DirectboxNotif.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function DirectboxNotifIcon({ className, dataTestid = "DirectboxNotifIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <DirectboxNotif data-testid={dataTestid} className={classes} {...rest} />
  );
}
